import React from 'react';
import Segmented from './Segmented';

// THE SHELVES — the categories an app or plugin sits on (third_parties.category,
// migration 277), as the Mac catalog names them. The developer picks one; NULL is
// "not chosen" and sits on no shelf. Apps and plugins share the vocabulary.
export const SHELVES = [
    { id: 'mind', label: 'Mind' },
    { id: 'body', label: 'Body' },
    { id: 'money', label: 'Money' },
    { id: 'words', label: 'Words' },
    { id: 'voice', label: 'Voice' },
    { id: 'build', label: 'Build' },
];

export const shelfOf = (thing) => thing?.category || null;

/** The shelves something in `things` sits on, each with how many. */
export function shelvesAmong(things) {
    const n = {};
    things.forEach((t) => { const s = shelfOf(t); if (s) n[s] = (n[s] || 0) + 1; });
    return SHELVES.filter((s) => n[s.id]).map((s) => ({ ...s, count: n[s.id] }));
}

/** The shelf filter in effect: a shelf that left the page stops filtering. */
export const shelfIn = (shelves, shelf) => (shelves.some((s) => s.id === shelf) ? shelf : 'all');

/** All | Mind | Body …, only the shelves present; nothing for fewer than two.
 *  Pressing the shelf you are on goes back to All. */
export function ShelfChips({ shelves, value, onChange }) {
    if (shelves.length < 2) return null;
    return (
        <div className="nx-filters">
            <Segmented
                label="Shelf"
                options={[{ id: 'all', label: 'All' }, ...shelves]}
                value={shelfIn(shelves, value)}
                onChange={(id) => onChange(value === id && id !== 'all' ? 'all' : id)}
            />
        </div>
    );
}
